
<template>
<div class="sales-distribution">
  <div class="block">
    <el-date-picker
      v-model="duration"
      type="daterange"
      align="right"
      unlink-panels
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      :picker-options="pickerOptions2">
    </el-date-picker>
  </div>
  <div class="chart"></div>
</div>
</template>

<script>
import axios from 'axios'
import echarts from 'echarts'
import china from 'echarts/map/js/china'

export default {

  props:['sales_data'],

  created() {
    this.data = this.sales_data
    this._getCityData()
  },

  data() {
    return {
      data: [],
      legendArr: [],
      myChart: {},
      geoCoordMap: {},
      pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        duration: '',
      }
  },

  watch: {
    duration: function (newQuestion, oldQuestion) {
      this._getMyChart()
    }
  },

  methods: {


    initialize(options) {
      this.myChart = echarts.init(document.querySelector('.sales-distribution .chart'))
      this.myChart.setOption(options, true)
      this.legendArr = options.series
      this.legendArr.forEach((data) => {
        data.selected = true;
      })
      window.addEventListener('resize', function() {
        this.myChart.resize()
      }.bind(this))
    },
    _getCityData() {
      axios.get('/static/city.json').then((res) => {
        this.geoCoordMap = res.data
        this.$nextTick(() => {
          this._getMyChart()
        })
      })
    },

    _getMyChart() {
        let options = {
          // backgroundColor: '#404a59',

          title: {
            show: true,
            text: '销售地区分布',
            textStyle: {
              color: '#000'
            },
            left: 'center',
            top: 15
          },
          tooltip: {},
          visualMap: {
            min: 0,
            max: 1500,
            color: '#000',
            left: 'left',
            top: 'bottom',
            splitNumber: 5,
            inRange: {
              color: ['#51D4EB', '#3BBCB0', '#2F9696', '#2A7484', '#255B78'],
            },
            textStyle: {
              color: '#000'
            },
          },
          geo: {
            map: 'china',
            roam: false,
            itemStyle: {
              normal: {
                borderColor: '#fff',
              },
              emphasis: {
                areaColor: null,
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                shadowBlur: 20,
                borderWidth: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            top: 30,
            bottom: 50
          },
          series: [
            {
              type: 'scatter',
              coordinateSystem: 'geo',
            },
            {
              name: '销量',
              type: 'map',
              geoIndex: 0,
              data: this.data
            }
          ]
        }
        this.initialize(options)
    }
  }
}
</script>

<!-- 散点图 -->
<style scoped lang="scss">


  .sales-distribution {
    height: 600px;
    width: 500px;

    .chart {
      height: 500px;
      width: 500px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/views/index/data-analysis/sales/sales-distribution.vue